/** Server-owned access and saved choice for the bundled Web visualization plugin. */
export interface VisualizeEntitlement {
  featureId: 'visualize';
  title: string;
  enabled: boolean;
  allowed: boolean;
  requiredPlans: string[];
  requiredPlanNames?: string[];
}

export const VISUALIZE_PLUGIN_ID = 'visualize@reados-bundled';
export const VISUALIZE_PLUGIN_VERSION = '1.0.41';
/** Stock app-server qualifies plugin skills as plugin-name:skill-name. */
export const VISUALIZE_SKILL_NAME = 'visualize:visualize';
